import { render } from "./narvar2.vue?vue&type=template&id=cc0fe35e&scoped=true"
import script from "./narvar2.vue?vue&type=script&lang=js"
export * from "./narvar2.vue?vue&type=script&lang=js"

import "./narvar2.vue?vue&type=style&index=0&id=cc0fe35e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0fe35e"]])

export default __exports__